import * as React from 'react';
import { StyleSheet, unstable_createElement } from 'react-native-web';

// Web stand-in for react-native-linear-gradient: renders a <div> with a CSS
// linear-gradient background. Supports the props this app uses (colors, start,
// end, locations, style, children).
export default function LinearGradient({
  colors = [],
  start = { x: 0, y: 0 },
  end = { x: 0, y: 1 },
  locations,
  style,
  children,
  ...rest
}) {
  const dx = (end.x ?? 0) - (start.x ?? 0);
  const dy = (end.y ?? 0) - (start.y ?? 0);
  // CSS angle: 0deg points up; clockwise. RN vector (dx,dy) with y pointing down.
  const angle = Math.round((Math.atan2(dx, -dy) * 180) / Math.PI);
  const stops = colors
    .map((c, i) => (locations && locations[i] != null ? `${c} ${locations[i] * 100}%` : c))
    .join(', ');
  const flat = StyleSheet.flatten(style) || {};
  return unstable_createElement('div', {
    ...rest,
    // Behave like an RN View (flex column) so children with flex:1 fill it.
    style: [{ display: 'flex', flexDirection: 'column' }, flat, { backgroundImage: `linear-gradient(${angle}deg, ${stops})` }],
    children,
  });
}
